import { render, staticRenderFns } from "./payment-type-redirect.vue?vue&type=template&id=3d677d00"
import script from "./payment-type-redirect.vue?vue&type=script&lang=js"
export * from "./payment-type-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports